<script setup lang="ts">
  import type { HTMLAttributes } from 'vue'
  import { reactiveOmit } from '@vueuse/core'
  import { cn } from '../../../lib/utils'
  import TableCell from './TableCell.vue'
  import TableRow from './TableRow.vue'

  const props = withDefaults(
    defineProps<{
      class?: HTMLAttributes['class']
      colspan?: number
    }>(),
    {
      colspan: 1
    }
  )

  const delegatedProps = reactiveOmit(props, 'class')
</script>

<template>
  <TableRow>
    <TableCell
      :class="
        cn(
          'text-foreground whitespace-nowrap p-4 align-middle text-sm',
          props.class
        )
      "
      v-bind="delegatedProps"
    >
      <div class="flex items-center justify-center py-10">
        <slot />
      </div>
    </TableCell>
  </TableRow>
</template>
